module.exports = __webpack_public_path__ + "static/whitepaper_zh-4e053cb8dff1ba3bcaf76e094fe4258b.pdf";